import {css} from 'styled-components';

export const LockStyleCss = css`
  .subscription-lock-wrapper {
    display: inline;
    width: fit-content;
  }

  .ant-select-selection-item {
    .subscription-lock-icon {
      display: none;
    }
  }
`;
